import React, { FC } from 'react';

export const GenericGridTableHead: FC<{
  label: string;
  sorter: (key: string) => void;
  field: string;
  className?: string;
  isSortable?: boolean;
}> = ({ label, sorter, field, className = '' }) => {
  return (
    <th scope="col" className={className} data-testid="generic-table-head">
      {label}
      <button
        aria-label={label}
        className="sort-icon"
        data-testid={`sort-button-${field}`}
        onClick={() => sorter(field)}
      />
    </th>
  );
};
GenericGridTableHead.displayName = 'GenericGridTableHead';
